import React from 'react';
import {formatDate} from "../../../services/UtilityService";
import PdfPage from "../../PdfPage";
import Images from "../../Images";

const CoverPage = ({ details }) => {
	const { child, parent } = details;

	const childCompletedAt = React.useMemo(() => {
		return formatDate(child.current_team.completed, 'MMMM DD, YYYY');
	}, [details]);

	const parentCompletedAt = React.useMemo(() => {
		return formatDate(parent.current_team.completed, 'MMMM DD, YYYY');
	}, [details]);

	return (
		<PdfPage sectionClassName={'CoverPage'}>
			<div className='CoverPage__layout'>
				<div className='CoverPage__banner'>
					<span className='CoverPage__bannerTitle'>Team Progress Report</span>
				</div>

				<div className='CoverPage__body'>
					<div className='CoverPage__logo'>
						<img src={Images.report.logo5d} alt='5 Dysfunctions of a Team' />
					</div>

					<div className='CoverPage__teamInfo'>
						{parent.current_team.team_type === 'individual' && (
							<span className='CoverPage__teamInfoName'>Individual Assessment</span>
						)}
						<span className='CoverPage__teamInfoName'>{child.current_team.name}</span>
						{child.current_team.company_name && (
							<span>{child.current_team.company_name}</span>
						)}
						<span>{`Completed: ${childCompletedAt}`}</span>
						<span>{`Original Assessment: ${parentCompletedAt}`}</span>
					</div>
				</div>

				<div className='CoverPage__footer'>
					<div className='CoverPage__poweredBy'>
						<img src={Images.report.poweredByTg} alt='Powered by The Table Group' />
					</div>
				</div>

				<div className='CoverPage__pyramid'>
					<img src={Images.report.pyramidWhiteFill} alt='' />
				</div>
			</div>
		</PdfPage>
	);
};

export default CoverPage;
